import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NewsApiResponse} from '../news.model';
import {endpoints} from '../../../core/configs/endpoints';

/**
 * Service to interact with the News API.
 * Provides methods to retrieve the users news.
 */
@Injectable({providedIn: 'root'})
export class NewsApiService {
  private readonly _httpClient = inject(HttpClient)

  public getNews(lang: string): Observable<NewsApiResponse> {
    return this._httpClient.get<NewsApiResponse>(`${endpoints.news.list(lang)}`) // TODO: Fix
  }
}
